module.exports = __webpack_public_path__ + "img/17.adcb0d44.png";